import { Image } from '@heroui/image';
import { CSSProperties, FC } from 'react';
import { cn } from '@/utils';
import { selectMainImage } from '@/utils/select-main-image';

type ImageItem = {
  image: string;
  title: string;
  description: string;
};

type Props = {
  items: ImageItem[];
  titleColor?: string;
  descriptionColor?: string;
  layout?: 'vertical' | 'horizontal';
  imageWidth?: number;
  imageHeight?: number;
  paddingStyle?: CSSProperties;
};

const DEFAULT_IMAGE_WIDTH = 200;
const DEFAULT_IMAGE_HEIGHT = 150;

const ImageCardsWithText: FC<Props> = ({
  items,
  titleColor,
  descriptionColor,
  layout = 'vertical',
  imageWidth = DEFAULT_IMAGE_WIDTH,
  imageHeight = DEFAULT_IMAGE_HEIGHT,
  paddingStyle,
}) => {
  const isHorizontal = layout === 'horizontal';

  return (
    <div
      className="container mx-auto flex w-full flex-col items-center gap-12 @md:gap-24"
      style={paddingStyle}
    >
      <div className="mx-4 mb-4 flex w-full flex-wrap justify-center gap-12">
        {items.map((item, index) => (
          <div
            key={index}
            className={cn(
              'flex w-full max-w-[260px] self-start px-2',
              isHorizontal ? 'flex-row items-start gap-4' : 'flex-col items-center gap-1',
            )}
          >
            <div className="overflow-hidden rounded-xl">
              <Image
                src={selectMainImage([item.image])}
                alt={item.title}
                width={imageWidth}
                height={imageHeight}
                className="object-cover"
                style={{ width: imageWidth, height: imageHeight }}
              />
            </div>
            <div className={cn(isHorizontal ? 'flex min-w-0 flex-1 flex-col gap-1' : 'contents')}>
              <span
                className={cn(
                  'text-md font-medium @md:text-lg',
                  isHorizontal ? 'text-left' : 'text-center',
                )}
                style={titleColor ? { color: titleColor } : undefined}
              >
                {item.title}
              </span>
              <span
                className={cn('text-sm text-zinc-600', isHorizontal ? 'text-left' : 'text-center')}
                style={descriptionColor ? { color: descriptionColor } : undefined}
              >
                {item.description}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCardsWithText;
